import { ZodSchema, ZodTypeDef, z } from "zod";

export const TokenDataAliasSchema = z.object({
  aliasTo: z
    .string()
    .optional()
    .nullable()
    .transform(v => v ?? undefined),
});

export function tokenAliasOrValue<I, O>(value: ZodSchema<I, ZodTypeDef, O>) {
  return TokenDataAliasSchema.extend({
    value: value
      .optional()
      .nullable()
      .transform(v => (v ?? undefined) as z.output<typeof value> | undefined),
  });
}
